import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { useGetAllConversationsQuery } from "@/redux/api/conversations_new.rtkq";
import { useLocation, useNavigate } from "react-router";
import { Clock } from "lucide-react";
import { toast } from "sonner";
import { useEffect } from "react";

const ConversationsHistoryMenuItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setOpenMobile } = useSidebar();

  const { data: conversationsList, error, isLoading, isSuccess, isError } = useGetAllConversationsQuery();

  useEffect(() => {
    if (isError) {
      console.error(error);
      toast.error("שגיאה במשיכת היסטוריה שיחות");
    }
  }, [isError, error]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isSuccess && conversationsList) {
    if (conversationsList.length === 0) {
      return <div className="px-3 py-2 text-sm text-slate-500 text-center">אין היסטוריית שיחות</div>;
    }

    return conversationsList.map((item, index) => (
      <SidebarMenuItem key={item?.conversation_id || index}>
        <SidebarMenuButton
          size="sm"
          isActive={location.pathname.split("/").pop() === item.conversation_id}
          onClick={() => {
            setOpenMobile(false);
            navigate(`/assistant/${item.conversation_id}`);
          }}
        >
          {index + 1}
          <Clock />
          <span>{item.conversation_name}</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    ));
  }

  return <div className="px-3 py-2 text-sm text-slate-500 text-center">שגיאה בטעינת היסטוריה</div>;
};

const ConversationsHistorySection = () => {
  return (
    <SidebarGroup>
      <SidebarGroupLabel>היסטורית שיחות</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <ConversationsHistoryMenuItems />
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default ConversationsHistorySection;
